export default {
  name: "pageloader",
  components: {},
  props: { visibility: Boolean, withbackground: Boolean },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
